import * as React from 'react';
import ReactDOM from 'react-dom';

import {ImportUnsubscribes} from './import-unsubscribes';

export function mountImportUnsubscribes() {
    const importUnsubscribesContainer = document.querySelector('#import-unsubscribes-react-mount');
    if (importUnsubscribesContainer) {
        ReactDOM.render(<ImportUnsubscribes />, importUnsubscribesContainer);
    }
}
